<div class="container">
  <a mat-button class="zapier-back-link" routerLink="/automations" data-test="zapier-back-to-automations">
    <mat-icon>arrow_back</mat-icon>
    {{ "automations.list.back-to-automations" | translate }}
  </a>
  @if (note) {
    <div class="note">
      <div class="note-content">
        <p>
          <strong>{{ note.type | translate }}:</strong>
          {{ note.message | translate }}
        </p>
        @if (!isLoading && apiKey) {
          <div class="rest-api-key-info">
            <span
              class="rest-api-key-value"
              matTooltipPosition="below"
              (click)="copyToClipboard(apiKey)"
              matTooltip="{{ 'generic.copyToClipboard.tooltip' | translate }}">
              {{ apiKey }}
            </span>
          </div>
        }
      </div>
    </div>
  }
  @if (!isLoading) {
    <zapier-workflow
      [clientId]="clientId"
      [theme]="userTheme"
      [introCopyDisplay]="introCopyDisplay"
      [manageZapsDisplay]="manageZapsDisplay"
      [appSelectionDisplay]="appSelectionDisplay"
      [appSearchBarDisplay]="appSearchBarDisplay"
      [zapCreateFromScratchDisplay]="zapCreateFromScratchDisplay"
      [guessZapDisplay]="guessZapDisplay"
      [templateLimit]="templateLimit"
      [templateCtaDisplay]="templateCtaDisplay"></zapier-workflow>
  }
  @if (isLoading) {
    <div>Loading Zapier Workflows...</div>
  }
</div>
